import { ReduxUtils } from '../../../dependencies';
import types from '../../actionTypes';

const actionTypes = {
    REQUEST: types.FETCH_SUPPLIERS_REQUEST,
    SUCCESS: types.FETCH_SUPPLIERS_SUCCESS,
    FAILURE: types.FETCH_SUPPLIERS_FAILURE,
    CANCEL: types.FETCH_SUPPLIERS_CANCEL,
};

export default ReduxUtils.basicApiReducer({
    actionTypes,
});
